window.checkEmail = function(value, options, key, attributes) {
	var email = attributes.email;
	var localPart = email ? email.slice(0, email.indexOf('@')) : '';

	if (localPart && value && value.includes(localPart)) return options.message;
};
